import styles from './home.module.css';

const Home = () => {

    return (
        <div className={styles.container} id="home">
            <div className={`${styles.aboutContainer} ${"about section"}`} id="about">
                <div className={styles.flex}>
                    <div className={styles.leftSection}>
                        <h1>Hi, I'm <span id="user-detail-name">Kanjariya Mehul Kumar</span></h1>
                        <h3>Full Stack Web Developer</h3>
                        <p id="user-detail-intro">A passionate programmer with a curious mind who loves solving problems. I have an experience of building Web applications with JS, REACT, HTML, CSS etc. I'm currently actively looking for new opportunities</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Home;